import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type DeleteCargoItemMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.DeleteCargoItemInput;
}>;

export type DeleteCargoItemMutationResult = { __typename?: 'Mutation' } & {
  cargoDeleteCargoItem?: GraphQLTypes.Maybe<
    { __typename?: 'DeleteCargoItemPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const DeleteCargoItemDocument = gql`
  mutation deleteCargoItem($input: DeleteCargoItemInput!) {
    cargoDeleteCargoItem(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
